import * as constantes from "../constants/constantes.js";
const ENDPOINT = constantes.URLAPI;
const ENDPOINTTEST = constantes.URL_TESTCURSO;

export const ListarCursos = async({jwt})=> {
    return await fetch(`${ENDPOINT}/ZADCurso/ListarCursos`,{
    //return await fetch(`${ENDPOINTTEST}/ListarCursos`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export const BuscarCursoID = async ({jwt,idCurso}) =>{
    return await fetch(`${ENDPOINT}/ZADCurso/BuscarCursoID/${idCurso}`,{
    //return await fetch(`${ENDPOINTTEST}/BuscarCursoID/${idCurso}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })   
}
export const ObtenerProgresoCursoPorPersonaCurso = async ({jwt, idPersonaCurso}) =>{
    return await fetch(`${ENDPOINT}/ZADCurso/ObtenerProgresoCursoPorPersonaCurso/${idPersonaCurso}`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerProgresoCursoPorPersonaCurso/${idPersonaCurso}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export async function ObtenerListaCategorias ({jwt}) {
    return await fetch(`${ENDPOINT}/ZADGeneral/ObtenerListaCategorias`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerListaCategorias`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export async function ObtenerEncuestaPersonaCurso ({jwt,idPersonaCurso}) {
    return await fetch(`${ENDPOINT}/ZADCurso/ObtenerEncuestaPersonaCurso/${idPersonaCurso}`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerEncuestaPersonaCurso/${idPersonaCurso}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}

export const RegistrarEncuestaPersonaCurso= ({encuestaCurso,jwt}) =>{
    //return fetch(`${ENDPOINTTEST}/RegistrarEncuestaPersonaCurso`,{
    return fetch(`${ENDPOINT}/ZADCurso/RegistrarEncuestaPersonaCurso`,{
        method: "POST",
        headers:{
            "Authorization":"Bearer "+jwt,
            'Content-Type': 'application/json',
            "accept": "application/json"
        },
        
        body: encuestaCurso
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}

export const ActualizarEncuestaPersonaCurso= ({encuestaCurso,jwt}) =>{
    //return fetch(`${ENDPOINTTEST}/ActualizarEncuestaPersonaCurso`,{
    return fetch(`${ENDPOINT}/ZADCurso/ActualizarEncuestaPersonaCurso`,{
        method: "POST",
        headers:{
            "Authorization":"Bearer "+jwt,
            'Content-Type': 'application/json',
            "accept": "application/json"
        },
        
        body: encuestaCurso
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}


export async function ObtenerEncuestaPersonaPrograma ({jwt,id}) {
    return await fetch(`${ENDPOINT}/ZADCurso/ObtenerEncuestaPersonaPrograma/${id}`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerEncuestaPersonaPrograma/${id}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}

export const RegistrarEncuestaPersonaPrograma= ({encuestaprograma,jwt}) =>{
    //return fetch(`${ENDPOINTTEST}/RegistrarEncuestaPersonaPrograma`,{
    return fetch(`${ENDPOINT}/ZADCurso/RegistrarEncuestaPersonaPrograma`,{
        method: "POST",
        headers:{
            "Authorization":"Bearer "+jwt,
            'Content-Type': 'application/json',
            "accept": "application/json"
        },
        
        body: encuestaprograma
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}

export const ActualizarEncuestaPersonaPrograma= ({encuestaprograma,jwt}) =>{
    //return fetch(`${ENDPOINTTEST}/ActualizarEncuestaPersonaPrograma`,{
    return fetch(`${ENDPOINT}/ZADCurso/ActualizarEncuestaPersonaPrograma`,{
        method: "POST",
        headers:{
            "Authorization":"Bearer "+jwt,
            'Content-Type': 'application/json',
            "accept": "application/json"
        },
        
        body: encuestaprograma
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}

export async function ObtenerEncuestaPuntuacion ({jwt}) {
    return await fetch(`${ENDPOINT}/ZADCurso/ObtenerEncuestaPuntuacion`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerEncuestaPuntuacion`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}
export const ObtenerProgresoCursoPorPersonaPrograma = async ({jwt, id}) =>{
    return await fetch(`${ENDPOINT}/ZADCurso/ObtenerProgresoCursoPorPersonaPrograma/${id}`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerProgresoCursoPorPersonaPrograma/${idCurso}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export const ObtenerEvaluacionesPersonaPrograma = async ({jwt, id}) =>{
    return await fetch(`${ENDPOINT}/ZADCurso/ObtenerEvaluacionesPersonaPrograma/${id}`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerEvaluacionesPersonaPrograma/${idCurso}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

